import React, { Fragment } from 'react';
import ImageUploading from 'react-images-uploading';
import { ADDIATATACODE, ADDIATATAGIMAGE, GetSystemObjects } from '../../globals'
// Portr SDK - api class and methods
import PortrSDK from 'portr-javascript-sdk';
import LoadingScreenComponent from '../loader/loading-screen.component';
import ToastComponent, { closeToast } from '../toast/toast.component';
import tickIcon from './../../images/tick-blue.svg';
import { replaceCount } from '../../services/string-helper';
// const brandTick = require('../../images/brandTick.svg');
// const camOutlineWhite = require('./../../images/cam-outline-white.svg');
const camOutlineblue = require('./../../images/cam-outline-blue.svg');
const portrSDK = new PortrSDK();
// images
const imgClose = require('../../images/icon_close.svg');
const imgCloseGray = require('../../images/icon-close-gray.svg');
const imgExample = require('../../images/example-iata-image.svg');
const arrowRight = require('../../images/right-arrow.svg');
const arrowBottom = require('../../images/bottom-arrow.svg');
// const imgQuestionMark = require('../../images/question-icon.svg');
// styles
const styles = require('./iata-upload.scss');
const API_PATH = process.env.REACT_APP_API_URL;
const SUBSCRIPTIONKEY = process.env.REACT_APP_SUBSCRIPTION_KEY;
const header = {
    'Ocp-Apim-Subscription-Key': SUBSCRIPTIONKEY
};

declare var exponea: any;
interface IProps {
    bookingJourneyReference: string;
    userBookingRef: string;
    language: string;
    multiLang: any;
    getData: Function;
    queryParams: any;
    trackingData: any;
}

interface IState {
    showOverlay: boolean;
    overlayClasses: string;
    images: Array<any>;
    compressedImages: Array<any>;
    uploadBaggageSuccess: boolean;
    uploading: boolean;
    error: any;
    isActive: boolean;
    showManualIataContent: boolean;
    iataInputText: string;
    iataInputID: number;
    iataList: Array<any>;
    linkedIataList: Array<any>;
    errorMsg: string;
    systemObject: Array<any>;
}
const maxNumber = 10;
let toastIndex = 0;
class IataUploadComponent extends React.Component<IProps, IState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showOverlay: false,
            overlayClasses: styles.modalWrapper,
            images: [],
            compressedImages: [],
            uploadBaggageSuccess: false,
            uploading: false,
            error: false,
            isActive: false,
            showManualIataContent: false,
            iataInputText: '',
            iataInputID: 1,
            linkedIataList: props.trackingData.trackingBookingDetails?.isDoorToDoorBooking ? props.trackingData.iataCodes : [],
            iataList: [],
            errorMsg: '',
            systemObject: []
        };
    }

    componentDidMount() {
        const req = { type: 'AirlinePrefixIataCode' };
        portrSDK.getTrackingDataWithHeader(
            API_PATH,
            GetSystemObjects,
            'post',
            null,
            req,
            header
        ).then(data => {
            this.setState({ systemObject: data.systemObject });
            console.log(data.systemObject);
        }).catch(error => {
            console.error('Error fetching systemObject data:', error);
        });
    }


    toggleCollapsible = () => {
        this.setState(prevState => ({
          isActive: !prevState.isActive
        }));
      };

    iataInputChangeHandler = (e) => {
        const val = e.target.value;
        this.setState({iataInputText: val})
    }

    validateIATACode = (code) => {
        const lengthValid = code.length >= 8 && code.length <= 10;

        if (!lengthValid) {
            return 'IATA code must be 8-10 characters long.'
        }
        // Only validate pattern after length check
        let patternValid = false;
        // For 8-character length, match format "AB123456"
        if (code.length === 8) {
            patternValid = /^[A-Z]{2}[0-9]{6}$/.test(code);
        } else if (code.length === 10) {
            // For 10-character length, match 10 digits only
            patternValid = /^[0-9]{10}$/.test(code);
        }
        // For 9-character length, it should not match either pattern, so set to false
        if (!patternValid) {
            return `IATA code must be in the format 'AB123456' or '0123456789'.`
        }

        // Check if the prefix (first 2 characters) exists in systemObject
        const prefix = code.substring(0, 2);
        const prefixExists = this.state.systemObject.some(
            (entry) => entry.AirlineCode === prefix
        );

        if (code.length !== 10 && !prefixExists) {
            return 'Airline code not found for IATA code';
        }

        return ''; // No error
    };

    submitIATA = () => {
        if (this.state.iataInputText !== '') {
            const error = this.validateIATACode(this.state.iataInputText);
            if (error) {
                this.setState({ errorMsg: error });
            } else {
                const newItem = {id: this.state.iataInputID, text: this.state.iataInputText}
                this.setState(prevState => ({
                    iataList: [...prevState.iataList, newItem],
                    iataInputText: '',
                    iataInputID: prevState.iataInputID + 1,
                    showManualIataContent: false,
                    errorMsg: ''
                }));
            }
        }
    }
    // Handler to remove an item by ID
    removeIATA = (id) => {
        this.setState(prevState => ({
            iataList: prevState.iataList.filter(item => item.id !== id)
        }));
    };
    manualIATAClick =  () => {
        this.setState({showManualIataContent: true});
    }

    uploadIATA = async (request) => {
        const res = await portrSDK.getTrackingDataWithHeader(
            API_PATH,
            ADDIATATACODE,
            'post',
            null,
            request,
            header
        );

        if (res.status && res.status >= 400) {
            this.setState({ errorMsg: res.data.validationErrors });
            return false;
        } else {
            console.log(res);
            this.setState({ uploading: false });
            const newItem = {id: this.state.iataInputID, text: this.state.iataInputText}
            this.setState(prevState => ({
                iataList: [...prevState.iataList, newItem],
                iataInputText: '',
                iataInputID: prevState.iataInputID + 1,
                showManualIataContent: false,
                errorMsg: ''
            }));
            return true;
        }

    }

    uploadImage = async (request) => {
        let isSuccess = true;
        let error = null;
        const res = await portrSDK.getTrackingDataWithHeader(
            API_PATH,
            ADDIATATAGIMAGE,
            'post',
            null,
            request,
            header
        );

        if (res.status && res.status >= 400) {
            isSuccess = false;
            error = res.data.validationErrors;
        }
        return [isSuccess, error];
    }

    // Compress a single image
    compressImage = (imageFile) => {
        return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result as string;

            img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const maxWidth = 800; // Set max width or height
            const maxHeight = 800;
            let width = img.width;
            let height = img.height;

            // Maintain aspect ratio
            if (width > height) {
                if (width > maxWidth) {
                height *= maxWidth / width;
                width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                width *= maxHeight / height;
                height = maxHeight;
                }
            }

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            // Convert canvas to blob (compressed image)
            canvas.toBlob((blob) => {
                if (blob) {
                const compressedImage = new File([blob], imageFile.name, {
                    type: 'image/jpeg',
                    lastModified: Date.now(),
                });
                resolve(compressedImage); // Resolve compressed image
                } else {
                reject(new Error('Compression failed'));
                }
            }, 'image/jpeg', 0.7); // Adjust quality here (0.7 is 70%)
            };

            img.onerror = () => reject(new Error('Image load error'));
        };

        reader.onerror = () => reject(new Error('File reader error'));
        reader.readAsDataURL(imageFile);
        });
    };

    onSendImageHandler = async () => {
        const { iataList, systemObject } = this.state;
        this.setState({ uploading: true });
        let iataUploadedSuccess = true;
        const getIataUploadType = () => {
            if (iataList.length === 0) {
                return 'Image';
            } else if (this.state.images.length === 0) {
                return 'Manual';
            } else {
                return 'Image & Manual';
            }
        }
        const uploadType = getIataUploadType();
        if (iataList.length > 0) {
            const processedIataArray = iataList.map((iataInputText) => {
                const iataCode = iataInputText.text
                // Check if the IATA code is a 10-digit number
                if (/^\d{10}$/.test(iataCode)) {
                    return iataCode; // Explicit return
                }
                const prefix = iataCode.substring(0, 2);
                const matchingEntry = systemObject.find(entry => entry.AirlineCode === prefix);
                let prefixCode;
                let numericPart
                let finalValue;
                if (matchingEntry) {
                    // If a match is found, retrieve its PrefixCode and perform further actions
                    prefixCode = matchingEntry.PrefixCode;
                    numericPart = iataCode.replace(/\D/g, '');
                    finalValue = '0' + prefixCode + numericPart;
                }
                return finalValue
            }).filter((code) => !!code);
            const req = {'bookingReference': `${this.props.userBookingRef}`, 'bookingJourneyReference': `${this.props.bookingJourneyReference}`, 'iataCodes': processedIataArray}
            const res = await this.uploadIATA(req);
            this.setState({ uploading: false });
            if (!res) {
                iataUploadedSuccess = false;
            }

            if (this.state.images.length === 0) {
                exponea.track('iata_uploaded', {
                    email: this.props.queryParams.email,
                    upload_successful: iataUploadedSuccess,
                    upload_type: uploadType
                });
                this.props.getData();
            }
        }

        const images = [...this.state.images]; // [1,2,3,4]
        if (images.length > 0) {
            this.setState({ uploading: true });
            const promises = await images.map((image) => this.compressImage(image.file));
                Promise.all(promises).then((compressedImages) => {
                    this.setState({ compressedImages }, () => {
                        // This callback will run after the state has been updated
                        let request;
                        let isLast = false;
                        let errors = [];

                        const failedImages = []; // [2,4]
                        this.state.compressedImages.forEach(async (img, i) => {
                            request = new FormData();
                            request.append('data', `{'bookingReference': '${this.props.userBookingRef}', 'bookingJourneyReference': '${this.props.bookingJourneyReference}'}`);
                            request.append('datafile', img);
                            const [isSuccess, error] = await this.uploadImage(request);

                            if (error) {
                                errors = error;
                            }

                            if (i === images.length - 1) {
                                isLast = true
                            }

                            if (!isSuccess) {
                                failedImages.push(i);
                            }

                            if (isLast) {
                                const failures = images.filter((item, j) => failedImages.includes(j));
                                if (failedImages.length > 0) {
                                    this.setState({ images: failures });
                                    this.setState({ error: true });
                                    this.setState({ error: errors });
                                    exponea.track('iata_uploaded', {
                                        email: this.props.queryParams.email,
                                        upload_successful: false,
                                        upload_type: uploadType
                                    });
                                } else {
                                    this.setState({ images: failures });
                                    this.setState({ uploadBaggageSuccess: true });
                                    exponea.track('iata_uploaded', {
                                        email: this.props.queryParams.email,
                                        upload_successful: true,
                                        upload_type: uploadType
                                    });
                                }
                                this.props.getData();
                                this.setState({ uploading: false });
                            }
                        });
                    });
            });
        }
    }

    onImageChange = (imageList, addUpdateIndex) => {
        this.setState({ images: imageList })
    };


    errorHandler = (error) => {
        if (typeof error === 'string') {
            toastIndex += 1;
            return <ToastComponent message={error} type='error' index={toastIndex} />
        } else {
            return error.map((err, i) => {
                toastIndex += 1;
                return <ToastComponent key={i} message={err} type='error' index={toastIndex} />
            });
        }
    }

    // handleClick = (val) => {
    //     this.setState({ showOverlay: val });
    //     if (val) {
    //       this.setState({ overlayClasses: styles.modalWrapper + ' ' + styles.fadeIn });
    //       document.getElementsByTagName('body')[0].classList.add(styles.bodyFixed);
    //     } else {
    //       this.setState({ overlayClasses: styles.modalWrapper + ' ' + styles.fadeOut });
    //       document.getElementsByTagName('body')[0].classList.remove(styles.bodyFixed);
    //     }
    //   }
    public render() {
        const { multiLang, language } = this.props;
        const { isActive, iataList, linkedIataList } = this.state;
        // const imgUploaded = this.state.uploadBaggageSuccess;
        return (
            <Fragment>
                {/* <div className={this.state.overlayClasses}>
                        <div className={styles.modal}>
                            <div className={styles.modalHeader}>
                                <h2>{multiLang['example' + language]}</h2>
                                <i onClick={e => this.handleClick(false)} className={styles.icon}>close</i>
                            </div>
                            <div className={styles.modalBody}>
                                <img src={imgExample} />
                            </div>
                        </div>
                </div> */}
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <span className={this.state.uploadBaggageSuccess ? styles.taskDone : ''}>{this.state.uploadBaggageSuccess ? multiLang['doneText' + language] : multiLang['uploadBoxTitle' + language]}</span>
                        {/* <div className={imgUploaded ? styles.textCompleted : styles.textTodo}>{imgUploaded ? (<>{multiLang[`doneText${language}`]} <img src={brandTick} alt='tick' /></>) : multiLang[`toDoText${language}`]}</div> */}
                    </div>
                    <div className={styles.cardBody}>
                        {this.state.uploadBaggageSuccess ?
                            <>
                                <img className={styles.centerImg} src={tickIcon} alt='' />
                                <h2 className={styles.textCenter}>{multiLang['thanksText' + language]}</h2>
                                <p>{multiLang['thanksMsgForIata' + language]}</p>
                            </>
                            :
                            <>
                                {/* <p>{multiLang['iataContent' + language]}</p> */}
                               <div className={styles.contentWrapper}>
                                <p>{multiLang['iataContent' + language]}</p>
                                    <ul>
                                        <li>{multiLang['iataContentList1' + language]}</li>
                                        <li>{multiLang['iataContentList2' + language]}</li>
                                        <li>{multiLang['iataContentList3' + language]}</li>
                                    </ul>
                               </div>
                                {this.state.uploading ? <>
                                    <div className={styles.backdrop}></div>
                                    <LoadingScreenComponent data={null}></LoadingScreenComponent>
                                </> : null}
                                <div className={styles.instructions}>
                                        {/* <img src={imgQuestionMark} />
                                        <span onClick={e => this.handleClick(true)}>{multiLang['needUpload' + language]}</span> */}
                                    <span className={`collapsible ${isActive ? 'active' : ''}`} onClick={this.toggleCollapsible}><span>{multiLang['exampleIata' + language]}</span> <img src={isActive ? arrowBottom : arrowRight} alt='' /></span>
                                    <div className='content' style={{ maxHeight: isActive ? '1000px' : '0px' }}>
                                        <img src={imgExample} />
                                    </div>
                                </div>
                                <ImageUploading
                                    multiple
                                    value={this.state.images}
                                    onChange={this.onImageChange}
                                    maxNumber={maxNumber}
                                    dataURLKey='data_url'
                                    acceptType={['jpg', 'jpeg', 'png']}
                                >
                                    {({
                                        imageList,
                                        onImageUpload,
                                        onImageRemoveAll,
                                        onImageUpdate,
                                        onImageRemove,
                                        isDragging,
                                        dragProps
                                    }) => (
                                        // write your building UI
                                        <>
                                            <div className={styles.uploadImageWrapper}>
                                                {imageList.map((image, index) => (
                                                    <>
                                                        <div key={index} className={styles.imageItem}>
                                                            <span>{replaceCount(multiLang[`addImageLabel${language}`], index + 1)}</span>
                                                            <div className={styles.imageWrapper}>
                                                                <div className={styles.imagePreview} style={{ backgroundImage: 'url(' + image.data_url + ')' }}></div>
                                                                {/* <button onClick={() => onImageUpdate(index)}>Re-take picture</button> */}
                                                                <div className={styles.crossIcon} onClick={() => onImageRemove(index)}>
                                                                    <img src={imgClose} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                ))}
                                                {/* image iata tags */}
                                                {this.state.images.length === 0 &&
                                                <>
                                                    <button onClick={onImageUpload}>
                                                        <img className={styles.btnImg} src={camOutlineblue} alt='' />
                                                        {multiLang['addIataPicture' + language]}
                                                    </button>
                                                </>
                                                }
                                            </div>
                                            {this.state.images.length > 0 &&
                                                    <button className={styles.btnAddAnother} onClick={onImageUpload}><img className={styles.btnImg} src={camOutlineblue} alt='' />{multiLang['addAnotherIataPicture' + language]}</button>
                                            }
                                            <div className={styles.textDivider}>
                                                <span className={styles.divider}></span>
                                                <span className={styles.text}>{multiLang['or' + language]}</span>
                                            </div>
                                            {/* text iata tags */}
                                            {(iataList.length > 0 || linkedIataList.length > 0) &&
                                                <div className={styles.manuallyAdded}>
                                                   { linkedIataList.length > 0 && (<>
                                                    <h2>{multiLang['linkedIataLabel' + language]}</h2>
                                                    <ul>
                                                        {linkedIataList.map((item, i) => (
                                                            <li key={i}>
                                                                {item}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    <div className={styles.textDivider}>
                                                        <span className={styles.divider}></span>
                                                        {/* <span className={styles.text}>{multiLang['or' + language]}</span> */}
                                                    </div>
                                                    </>)}

                                                    <h2>{multiLang['munallayIataTagLabel' + language]}</h2>
                                                    <ul>
                                                        {iataList.map((item, i) => (
                                                            <li key={i}>
                                                                {item.text}  <img src={imgCloseGray} onClick={() => this.removeIATA(item.id)} />
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            }
                                            {!this.state.showManualIataContent &&
                                                <span className={styles.manuallyButton} onClick={this.manualIATAClick}>+ {multiLang['addIataTagNumberManually' + language]}</span>
                                            }
                                            {this.state.showManualIataContent &&
                                                <div className={styles.showIATAContent}>
                                                    <h2>{multiLang['enterIataTag' + language]}</h2>
                                                    <p>Eg. BA728359 or 0125728359</p>
                                                    <input type='text' onChange={(e) => this.iataInputChangeHandler(e)} placeholder={multiLang['iataTagNumber' + language]} />
                                                    <p className={styles.erroMsg}>
                                                    {multiLang[this.state.errorMsg + language]}
                                                    </p>
                                                    <span className={this.state.iataInputText === '' && `${styles.disabled}`} onClick={this.submitIATA}>{multiLang['submitButton' + language]}</span>
                                                </div>
                                            }
                                            {(this.state.iataList.length > 0 || this.state.images.length > 0) &&
                                                <>
                                                    <div className={styles.textDivider}>
                                                        <span className={styles.divider}></span>
                                                        <span className={styles.text}></span>
                                                    </div>
                                                    <button className={styles.btnSendPicture} onClick={this.onSendImageHandler}>{multiLang['sendIataPicText' + language]}</button>
                                                </>
                                            }
                                        </>
                                    )}
                                </ImageUploading>
                                <div>
                                    {this.state.error.length > 0 ?
                                        <>
                                            <button className={styles.closeBtn} onClick={() => { closeToast(); this.setState({ error: [] }) }}>x</button>
                                            {this.errorHandler(this.state.error[0])}
                                        </>
                                        : null}
                                </div>
                            </>
                        }
                    </div>

                </div>
            </Fragment>
        );
    }
}

export default IataUploadComponent;



// WEBPACK FOOTER //
// ./src/components/baggage-receipt/iata-upload.component.tsx